import * as actionTypes from "./actionTypes";
import axios from "axios";
import api from "../../shared/api";

//get agents
export const getAgentsStart=()=>{
    return {
        type:actionTypes.GET_AGENTS_START
    }
}

export const getAgentsSuccess=(allAgents)=>{
    return {
        type:actionTypes.GET_AGENTS_SUCCESS,
        agents:allAgents,
    }
}

export const getAgentsFail=(errorMessage)=>{
    return {
        type:actionTypes.GET_AGENTS_FAIL,
        error:errorMessage,
    }
}

//create agents
export const createAgentStart=()=>{
    return {
        type:actionTypes.CREATE_AGENT_START
    }
}

export const createAgentSuccess=(successMessage)=>{
    return {
        type:actionTypes.CREATE_AGENT_SUCCESS,
        message:successMessage,
    }
}

export const createAgentFail=(errorMessage)=>{
    return {
        type:actionTypes.CREATE_AGENT_FAIL,
        error:errorMessage,
    }
}

//update agent
export const updateAgentStart=()=>{
    return {
        type:actionTypes.UPDATE_AGENT_START
    }
}

export const updateAgentSuccess=(successMessage)=>{
    return {
        type:actionTypes.UPDATE_AGENT_SUCCESS,
        message:successMessage
    }
}

export const updateAgentFail=(errorMessage)=>{
    return {
        type:actionTypes.UPDATE_AGENT_FAIL,
        error:errorMessage
    }
}

//get agent detail
export const getAgentDetailStart=()=>{
    return {
        type:actionTypes.GET_AGENT_DETAIL_START
    }
}

export const getAgentDetailSuccess=(agent)=>{
    return {
        type:actionTypes.GET_AGENT_DETAIL_SUCCESS,
        agentDetail:agent
    }
}

export const getAgentDetailFail=(errorMessage)=>{
    return {
        type:actionTypes.GET_AGENT_DETAIL_FAIL,
        error:errorMessage
    }
}
 
//update agent detail
export const updateAgentDetailStart=()=>{
    return {
        type:actionTypes.UPDATE_AGENT_DETAIL_START
    }
}

export const updateAgentDetailSuccess=(successMessage)=>{
    return {
        type:actionTypes.UPDATE_AGENT_DETAIL_SUCCESS,
        message:successMessage
    }
}

export const updateAgentDetailFail=(errorMessage)=>{
    return {
        type:actionTypes.UPDATE_AGENT_DETAIL_FAIL,
        error:errorMessage
    }
}

//add agentProduct
export const addAgentProductStart=()=>{
    return {
        type:actionTypes.ADD_AGENT_PRODUCT_START
    }
}

export const addAgentProductSuccess=(successMessage)=>{
    return {
        type:actionTypes.ADD_AGENT_PRODUCT_SUCCESS,
        message:successMessage
    }
}

export const addAgentProductFail=(errorMessage)=>{
    return {
        type:actionTypes.ADD_AGENT_PRODUCT_FAIL,
        error:errorMessage
    }
}

//update AgentProduct
export const updateAgentProductStart=()=>{
    return {
        type:actionTypes.UPDATE_AGENT_PRODUCT_START,
    }
}

export const updateAgentProductSuccess=()=>{
    return {
        type:actionTypes.UPDATE_AGENT_PRODUCT_SUCCESS,
    }
}

export const updateAgentProductFail=()=>{
    return {
        type:actionTypes.UPDATE_AGENT_PRODUCT_FAIL,
    }
}

//edit agent form
export const openAgentEdit=()=>{
    return {
        type:actionTypes.OPEN_AGENT_EDIT
    }
}

export const closeAgentEdit=()=>{
    return {
        type:actionTypes.CLOSE_AGENT_EDIT
    }
}

//add agentProduct form

export const openAgentProductAdd=()=>{
    return {
        type:actionTypes.OPEN_AGENT_PRODUCT_ADD
    }
}

export const closeAgentProductAdd=()=>{
    return {
        type:actionTypes.CLOSE_AGENT_PRODUCT_ADD
    }
}

//update agentProduct form
export const openAgentProductEdit=(ap)=>{
    return {
        type:actionTypes.OPEN_AGENT_PRODUCT_EDIT,
        agentProduct:ap,
    }
}

export const closeAgentProductEdit=()=>{
    return {
        type:actionTypes.CLOSE_AGENT_PRODUCT_EDIT
    }
}

//get Agents implementation
export const getAgents=(token)=>{
    return async dispatch=>{
        dispatch(getAgentsStart());
        let url =`${api}/agents`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{}
          };
          await axios(options)
          .then(response => {
          dispatch(getAgentsSuccess(response.data));
        })
        .catch(err => {
          dispatch(getAgentsFail(`Get Agents Failed - ${err}`));
        });
    }
}

//create agent implementation 
export const createAgent=(agent,token)=>{
    return async dispatch=>{
        dispatch(createAgentStart());
        let url =`${api}/agents`;
        const options = {
            url: url,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:agent
          };
          await axios(options)
          .then(response => {
          dispatch(createAgentSuccess("Create Agent Success"));
        })
        .catch(err => {
          dispatch(getAgentsFail(`Create Agent Failed - ${err}`));
        });
    }
}

//get agent detail implementation
export const getAgentDetail=(id,token)=>{
    return async dispatch=>{
        dispatch(getAgentDetailStart());
        let url =`${api}/agents/${id}`;
        const options = {
            url: url,
            method: 'GET',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{}
          };
          await axios(options)
          .then(response => {
          dispatch(getAgentDetailSuccess(response.data));
        })
        .catch(err => {
          dispatch(getAgentDetailFail(`Get Agent Detail Failed - ${err}`));
        });
    }
}

//update agent implementation
export const updateAgent=(agent,token)=>{
    return async dispatch=>{
        dispatch(updateAgentDetailStart());
        let url =`${api}/agents/${agent.id}`;
        const options = {
            url: url,
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{
                name:agent.name,
                mobile:agent.mobile
            }
          };
          await axios(options)
          .then(response => {
            dispatch(updateAgentDetailSuccess());
            dispatch(getAgentDetail(agent.id,token));
            dispatch(getAgents(token));
        })
        .catch(err => {
            dispatch(updateAgentDetailFail());
        });
    }
}


//add agent product

export const addAgentProduct=(id,agentProduct,token)=>{
    return async dispatch=>{
        dispatch(addAgentProductStart());
        let url =`${api}/agents/${id}/agentProducts`;
        const options = {
            url: url,
            method: 'POST',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:agentProduct
          };
          await axios(options)
          .then(response => {
           dispatch(addAgentProductSuccess('add agent product success'));
           dispatch(getAgentDetail(id,token));
        })
        .catch(err => {
            dispatch(addAgentProductFail('add agent product fail'+err));
        });
    }
}


//update Agent Product
export const updateAgentProduct=(agentId,agentProduct,token)=>{
    return async dispatch=>{
        dispatch(updateAgentProductStart());
        let url =`${api}/agents/${agentId}/agentProducts/${agentProduct.id}`;
        const options = {
            url: url,
            method: 'PUT',
            headers: {
                'Authorization': 'Bearer '+token
             },
            data:{
                productId:agentProduct.productId,
                unitPrice:agentProduct.unitPrice,
                extraCommission: agentProduct.extraCommission          
            }
          };
          await axios(options)
          .then(response => {
           dispatch(updateAgentProductSuccess('update agent product success'));
           dispatch(getAgentDetail(agentId,token));
        })
        .catch(err => {
            dispatch(updateAgentProductFail('update agent product fail'+err));
        });
    }
}

//set last reported date
export const setLastReportedDate=(date)=>{
    return {
        type:actionTypes.SET_LAST_REPORTED_DATE,
        payload:date
    }
}
